
/**
 * @sveltech/routify 1.6.6
 * File generated Tue Apr 27 2021 11:35:15 GMT+0200 (GMT+02:00)
 */

export const __version = "1.6.6"
export const __timestamp = "2021-04-27T09:35:15.498Z"

//buildRoutes
import { buildClientTree } from "/Users/asedano/Sites/control-horario/empleado/node_modules/@sveltech/routify/runtime/buildRoutes"

//imports
import __layout from '/Users/asedano/Sites/control-horario/empleado/src/pages/_layout.svelte'
import _calendario from '/Users/asedano/Sites/control-horario/empleado/src/pages/calendario.svelte'
import _index from '/Users/asedano/Sites/control-horario/empleado/src/pages/index.svelte'
import _login__reset from '/Users/asedano/Sites/control-horario/empleado/src/pages/login/_reset.svelte'
import _login_index from '/Users/asedano/Sites/control-horario/empleado/src/pages/login/index.svelte'
import _logout from '/Users/asedano/Sites/control-horario/empleado/src/pages/logout.svelte'
import _marcajes__mes from '/Users/asedano/Sites/control-horario/empleado/src/pages/marcajes/[mes].svelte'
import _marcajes_index from '/Users/asedano/Sites/control-horario/empleado/src/pages/marcajes/index.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "name": "root",
  "filepath": "/",
  "root": true,
  "children": [
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": true,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "meta": {
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/",
      "id": "__layout",
      "component": () => __layout
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "meta": {
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/calendario",
      "id": "_calendario",
      "component": () => _calendario
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": true,
      "isFallback": false,
      "isPage": true,
      "meta": {
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/index",
      "id": "_index",
      "component": () => _index
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": true,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "meta": {
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/login",
          "id": "_login__reset",
          "component": () => _login__reset
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "meta": {
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/login/index",
          "id": "_login_index",
          "component": () => _login_index
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "meta": {
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/login"
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "meta": {
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/logout",
      "id": "_logout",
      "component": () => _logout
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "meta": {
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/marcajes/:mes",
          "id": "_marcajes__mes",
          "component": () => _marcajes__mes
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "meta": {
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/marcajes/index",
          "id": "_marcajes_index",
          "component": () => _marcajes_index
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "meta": {
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/marcajes"
    }
  ],
  "isLayout": false,
  "isReset": false,
  "isIndex": false,
  "isFallback": false,
  "meta": {
    "preload": false,
    "precache-order": false,
    "precache-proximity": true,
    "recursive": true
  },
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

